import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'

@Component({
    selector: 'app-empty',
    template: ` <p></p> `,
    styles: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EmptyComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
